<template>
    <label class="BaseLabel" v-once>{{translate(text)}}</label>
</template>

<script>
    export default {
        name: 'BaseLabel',
        props: {
            //Text of the label
            text: {
                type: String,
                required: true
            }
        }
    };
</script>

<style>
    .BaseLabel {
        font-size: 14px;
        color: rgba(96, 125, 139,0.7);
    }
</style>



// WEBPACK FOOTER //
// BaseLabel.vue?5d46a82a